<mat-card appearance="outlined" class="default-card">
    <mat-card-header>
        <mat-card-title>Edition d'un lien</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <div class="form-item">
                <mat-form-field class="mat-form-field-text">
                    <mat-label>Libellé du lien</mat-label>
                    <input matInput [formControl]="labelFormControl" [(ngModel)]="link.displayName" autocomplete="off" required />
                </mat-form-field>
                <mat-form-field class="mat-form-field-text">
                    <mat-label>Url du lien</mat-label>
                    <input matInput [formControl]="urlFormControl" [(ngModel)]="link.url" autocomplete="off" required />
                </mat-form-field>
            </div>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" (click)="cancel()">Annuler</button>
        <button mat-raised-button class="accent-button" (click)="validate()" [disabled]="!(labelFormControl.valid && urlFormControl.valid)">Enregistrer</button>
    </mat-card-actions>
</mat-card>
